<template>
  <v-container >
    <v-row class="justify-center align-end">
    <v-card class="mt-5 ml-5 mr-5" elevation="0" color="transparent" :style="widthcard">
      <v-card-title primary-title>
        <h3 style="color:#205295;">{{ lg_account_edit_admin.title }}</h3>  
      </v-card-title>
      <!-- <v-divider></v-divider> -->
      <v-card-text>
        <v-form @submit.prevent="submit" ref="form">
        
          <div>
            <strong class="success--primary text-h6" style="color:#205295;">{{
              lg_account_edit_admin.license_type
            }}</strong>
          </div>
              <v-row  class="justify-center  mt-5 ">
               <v-col cols="12" md="7">
          <v-radio-group row v-model="account.acc_plan"  @change="onChangeplantype">
            <v-radio value="FREE" class="text-h6">
              <template v-slot:label >
                <div>
                  {{ lg_account_edit_admin.cb_free }} 
                  <!-- (<strong
                    class="info--text"
                    >{{ daysLeft }}</strong
                  >) -->
                </div>
              </template>
            </v-radio>
             <v-radio
             @change=""
             class="text-h6"
              :label="lg_account_edit_admin.titlepro"
              value="PRO"
            ></v-radio>
              <v-radio
              class="text-h6"
              :label="lg_account_edit_admin.titlebusiness"
              value="BUSINESS"
            ></v-radio>
              <v-radio
              class="text-h6"
              :label="lg_account_edit_admin.titleenterprise"
              value="ENTERPRISE"
            ></v-radio>
            <!-- <v-radio
              :label="lg_account_edit_admin.cb_premium"
              value="PREMIUM"
            ></v-radio> -->
          </v-radio-group>
          </v-col>
           <v-col cols="12" md="5">
            <!--  @change="onPermissionChange" -->
                  <v-select
            v-validate="'required'"
            :items="
              role == 'Admin' ? role_items_admin : role_items_company_admin
            "
            :label="lg_account_edit_admin.txt_permission"
            item-text="role"
            item-value="role"
            v-model="account.role"
            outlined
            dense
           
          ></v-select>
           </v-col>
          </v-row>
          <!-- <v-select
            v-validate="'required'"
            :items="mDataArray"
            :label="lg_account_edit_admin.sl_company"
            item-text="company_name"
            item-value="id"
            v-model="account.company_id"
            outlined
            @change="changeCompany"
          ></v-select> -->
<!-- 
          <v-select
            v-validate="'required'"
            :items="mDataArrayDepartment"
            :label="lg_account_edit_admin.sl_department"
            item-text="department"
            item-value="id"
            v-model="account.department_id"
            outlined
            @change="changeDepartment"
          ></v-select> -->

                      <v-row  class="justify-center  mt-5 ">
               <v-col cols="12" md="6">
          <v-text-field
            :label="lg_account_edit_admin.txt_fname"
            v-model="account.acc_fname"
            outlined
            required
            dense
            :rules="commonRules"
          />
</v-col>
   <v-col cols="12" md="6">
            <v-text-field
            :label="lg_account_edit_admin.txt_lname"
            v-model="account.acc_lname"
            outlined
             required
             dense
             :rules="commonRules"
          />
          </v-col>
            </v-row>

          <!-- <v-text-field
            :label="lg_account_edit_admin.txt_name"
            v-model="account.acc_fullname"
            outlined
            dense
          /> -->
          
           <v-row  class="justify-center  mt-5 ">
               <v-col cols="12" md="6">
                   <v-text-field
            :label="lg_account_edit_admin.email"
            v-model="account.username"
            disabled
            outlined
            dense
          />
</v-col>
   <v-col cols="12" md="6">
            <v-menu
            ref="menu1"
            v-model="menu1"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="auto"
          >
  
            <template v-slot:activator="{ on, attrs }">
              <!--  prepend-icon="mdi-calendar" -->
              <v-text-field
                v-model="dateFormatted"
                :label="lg_account_edit_admin.dtp_birthday"
                persistent-hint
                v-bind="attrs"
                outlined
                dense
                disabled
                @blur="date = parseDate(dateFormatted)"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date"
              no-title
              @input="menu1 = false"
            ></v-date-picker>
          </v-menu>
          </v-col>
            </v-row>



          

          <!-- <v-text-field
            :label="lg_account_edit_admin.txt_phone"
            v-model="account.acc_tel"
            outlined
          /> -->

          <!-- <v-select
            v-validate="'required'"
            :items="
              role == 'Admin' ? role_items_admin : role_items_company_admin
            "
            label="Department"
            item-text="role"
            item-value="role"
            v-model="account.role"
            outlined
            @change="onDepartmentChange"
          ></v-select> -->

          

    
          <!-- <v-row class="justify-space-between px-3 pt-5 pb-5">
            <v-btn
              outlined
              text
              @click.prevent="$router.push('/list-account')"
              >{{ lg_account_edit_admin.btn_cancel }}</v-btn
            >
            <v-btn type="submit" color="primary">{{
              lg_account_edit_admin.btn_save
            }}</v-btn>
          </v-row> -->

            <v-row  class="justify-center">
            <v-btn type="submit" color="primary" class="" >{{
              lg_account_edit_admin.btn_save
            }}</v-btn>
     
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
    </v-row>

    <!-- Alert Dialog -->
    <v-dialog v-model="alertDlg" max-width="60%">
      <v-card>
        <v-card-title class="headline">{{
          this.titleMessageAlert
        }}</v-card-title>

        <v-card-text class="body">
          {{ this.messageAlert }}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            text
            @click="alertDlg = false"
            col="12"
            lg="12"
            md="12"
            sm="12"
          >
            Close
          </v-btn>

          <!-- <v-btn outlined color="error" text @click="confirmDelete">
            Confirm
          </v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Alert Dialog -->

    <!-- Complete Dialog -->
    <v-dialog v-model="completeDlg" max-width="60%">
      <v-card>
        <v-card-title class="headline">{{
          this.titleMessageAlert
        }}</v-card-title>

        <v-card-text class="body">
          {{ this.messageAlert }}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            text
            @click="onclickcompleteDlg()"
            col="12"
            lg="12"
            md="12"
            sm="12"
          >
            Close
          </v-btn>

          <!-- <v-btn outlined color="error" text @click="confirmDelete">
                Confirm
              </v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Complete Dialog -->

    <LoadingDialog></LoadingDialog>
  </v-container>
</template>

<script>
import api from "@/services/api";
import LoadingDialog from "../../components/cards/LoadingDialog.vue";

import { feature } from "../../services/constants";
import { lg_account_edit_admin } from "../language/lg_account_edit_admin";
import { lg_account_detail_edit } from "../language/lg_account_detail";

export default {
  name: "account-edit-admin",
  beforeCreate() {
    localStorage.getItem(feature.LANGUAGE) === "th"
      ? (this.lg_account_edit_admin =
          lg_account_edit_admin.account_edit_admin_th)
      : (this.lg_account_edit_admin =
          lg_account_edit_admin.account_edit_admin_en);

              localStorage.getItem(feature.LANGUAGE) === "th"
      ? (this.lg_account_detail_edit = lg_account_detail_edit.account_detail_th)
      : (this.lg_account_detail_edit =
          lg_account_detail_edit.account_detail_en);

    if (this.resultJson == null) {
      this.checkData = false;
    }
  },
  async mounted() {
    this.role = localStorage.getItem("role");
    this.account.id = this.$route.params.id;
    this.$store.state.loadMenu = true;
    this.loadGuest();
    this.loadAccountData();
    this.loadCompany();
  },
  data(vm) {
    return {
      commonRules: [(v1) => !!v1 || this.lg_account_edit_admin.rules_commond],
      role_items_admin: [
        { role: "Admin" },
        { role: "Company Admin" },
        { role: "Member" },
        { role: "Guest" },
      ],
      role_items_company_admin: [
        { role: "Company Admin" },
        { role: "Member" },
        { role: "Guest" },
      ],
      role: "",
      resultJson: null,
      geust_id: "",
      geust_name: "",
      geust_ckeck: false,
      resultJsonCompanyName: null,
      checkData: false,
      alertDlg: false,
      completeDlg: false,
      titleMessageAlert: "",
      messageAlert: "",
      account: {
        id: 0,
        username: "",
        company_id: 0,
        department_id: 0,
        acc_fullname: "",
        acc_fname:"",
        acc_lname:"",
        acc_id_card: "",
        acc_tel: "",
        acc_birth: null,
        role: "",
        department: "",
        acc_plan: "",
        created_at: "",
      },
      date: new Date().toISOString().substr(0, 10),
      dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
      menu1: false,
      mDataArray: [],
      mDataArrayGuest: [],
      mDataArrayDepartment: [],
      daysLeft: undefined,
    };
  },
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
     widthcard() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "width:90%";
        case "sm":
          return "width:70%";
        case "md":
          return "width:70%";
        case "lg":
          return "width:60%";
        case "xl":
          return "width:60%";
      }
    },
  },
  watch: {
    date(val) {
      this.dateFormatted = this.formatDate(this.date);
    },
  },
  components: {
    LoadingDialog,
  },
  methods: {
    changeDepartment(selectObj) {
      console.log(selectObj);
    },
    async changeCompany(selectObj) {
      if (this.account.company_id == this.geust_id) {
        this.account.role = this.geust_name;
      } else {
        this.account.role = "Member";
      }
      console.log(selectObj);
      this.loadDepartment(selectObj);
    },
    async loadDepartment(id) {
      // console.log("loadDepartment")
      let result = await api.getAllDepartmentByCompanyId(id);
      // console.log(result)
      this.mDataArrayDepartment = result.data;
      // console.log(JSON.stringify(result.data));
    },
    async submit() {
      if (this.$refs.form.validate()) {
      this.$store.state.loadMenu = true;

      this.account.acc_fullname = `${this.account.acc_fname} ${this.account.acc_lname}`;
      const result_update_account = await api.updateAccount(
        this.account.id,
        this.account
      );

       if(result_update_account.status == 401){
      this.$store.state.loadMenu = false;
       this.$store.dispatch("doLogout");
        return;
      }
   
      if (result_update_account.status == 200) {
        this.$store.state.loadMenu = false;
                   this.$swal.fire({
  title:`<span style="color:black;">${this.lg_account_detail_edit.information_updated_success}</span>`,
  html:`<span style="color:black;">${this.lg_account_detail_edit.information_updated_success_details}</span>`,
  showDenyButton: false, 
  showCancelButton: false, 
  confirmButtonText: `${this.lg_account_detail_edit.close}`,
  denyButtonText: `${this.lg_account_detail_edit.close}`,
  confirmButtonColor: '#205295',
  denyButtonColor: '#000000',
  allowOutsideClick: true, 
  allowEscapeKey: true,  
  allowEnterKey: true   
}).then((result) => {
  if (result.isConfirmed) {
  } else if (result.isDenied) {
  }
});
      } else {
        // alert("result_update_account.data == null");
        this.$store.state.loadMenu = false;
      }
       }else{
                 this.$swal.fire({
  title:`<span style="color:black;">${this.lg_account_detail_edit.something_went_wrong}</span>`,
  html:`<span style="color:black;">${this.lg_account_detail_edit.something_went_wrong_details1}<br/>
    ${this.lg_account_detail_edit.something_went_wrong_details2}</span>`,
  showDenyButton: false, 
  showCancelButton: false, 
  confirmButtonText: `${this.lg_account_detail_edit.close}`,
  denyButtonText: `${this.lg_account_detail_edit.close}`,
  confirmButtonColor: '#205295',
  denyButtonColor: '#000000',
  allowOutsideClick: true, 
  allowEscapeKey: true,  
  allowEnterKey: true   
}).then((result) => {
  if (result.isConfirmed) {
  } else if (result.isDenied) {
  }
});
    }
    },
    onclickcompleteDlg() {
      this.completeDlg = false;
      this.$router.push("/list-account");
    },
    onPermissionChange() {
      if (this.account.role == this.geust_name) {
        this.account.company_id = this.geust_id;
      } else {
        if (this.account.company_id == this.geust_id) {
          // this.titleMessageAlert = "กรุณาตรวจสอบข้อมูล";
          this.titleMessageAlert = this.lg_account_edit_admin.dialog_check_data;
          // this.messageAlert = "กรุณาเลือกบริษัท";
          this.messageAlert = this.lg_account_edit_admin.dialog_select_company;
          this.alertDlg = true;
        }
      }
    },
    onDepartmentChange() {},
    onCompanyChange() {
      if (this.account.company_id == this.geust_id) {
        this.account.role = this.geust_name;
      } else {
        this.account.role = "Member";
      }
    },
    async loadGuest() {
      this.mDataArrayGuest = [];

      let result = await api.getCompanyGuestId();
       if(result.status == 401){
      this.$store.state.loadMenu = false;
       this.$store.dispatch("doLogout");
        return;
      }
      // console.log("loadGuest : " + JSON.stringify(result.data));
      this.mDataArrayGuest = result.data.rows;

      // console.log("loadGuest : " + this.mDataArrayGuest[0].id);
      // console.log("loadGuest : " + this.mDataArrayGuest[0].company_name);
      // console.log("loadGuest2 : " + JSON.stringify(result.data.id));
      this.geust_id = this.mDataArrayGuest[0].id;
      this.geust_name = this.mDataArrayGuest[0].company_name;
    },
    async loadCompany() {
      let result = await api.getAllCompany();
       if(result.status == 401){
      this.$store.state.loadMenu = false;
       this.$store.dispatch("doLogout");
        return;
      }
      this.mDataArray = result.data;
      // console.log(JSON.stringify(result.data));
    },
    async loadAccountData() {
      // alert(JSON.stringify(username));
      this.resultJson = await api.getAccountById(this.account.id);
        if(this.resultJson.status == 401){
      this.$store.state.loadMenu = false;
       this.$store.dispatch("doLogout");
        return;
      }
      // alert(JSON.stringify(this.resultJson.data.company_id));
      this.resultJsonCompanyName = await api.getCompanyByID(
        this.resultJson.data.company_id
      );

      this.loadDepartment(this.resultJson.data.company_id);

      // this.account.id = this.resultJson.data.id
      this.account.company_id = this.resultJson.data.company_id;
      this.account.department_id = this.resultJson.data.department_id;
      this.account.acc_fullname = this.resultJson.data.acc_fullname;
      this.account.acc_fname = this.resultJson.data.acc_fullname.trim().split(/\s+/)[0];
      this.account.acc_lname = this.resultJson.data.acc_fullname.trim().split(/\s+/)[1];
      this.account.acc_id_card = this.resultJson.data.acc_id_card;
      this.account.username = this.resultJson.data.username;
      this.account.acc_birth = this.resultJson.data.acc_birth;
      this.dateFormatted = this.resultJson.data.acc_birth;
      this.account.acc_tel = this.resultJson.data.acc_tel;
      this.account.role = this.resultJson.data.role;
      this.account.acc_plan = this.resultJson.data.acc_plan;
      this.account.created_at = this.resultJson.data.created_at;
      this.calculateDaysLeft(this.account.created_at);
      // alert(JSON.stringify(this.resultJsonCompanyName.data));
      this.checkData = true;
      this.$store.state.loadMenu = false;
    },
    calculateDaysLeft(created_at) {
      const created = new Date(created_at);
      const today = new Date();
      const difference_in_time = today.getTime() - created.getTime();
      const difference_in_days = difference_in_time / (1000 * 3600 * 24);
      const daysInt = Math.ceil(difference_in_days);
      this.daysLeft = daysInt >= 90 ? "Expired" : `${90 - daysInt} days left`;
    },
    onChangeplantype(value){
      if(value != "FREE"){
        this.account.role = "Member";
      }else{
    this.account.role = "Guest";
      }

    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${year}-${month}-${day}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
  },
};
</script>

<style scoped>

</style>
